import {Box, IconButton, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import Icon from 'presentation/icons';
import {useAccountInformation, useMediaQueries} from 'presentation/pages';
import {ProfileMenu} from '../ProfileMenu';
import {StyledRouteContainer} from '../styles';
import {RoutesHandlerProps} from './types';
import {Breadcrumbs} from '../Breadcrumbs';
import {FeaturesEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {useContractStatus} from 'presentation/hooks';
import {NotificationsButton} from '../NotificationsButton';

export function RoutesHandler({
	title,
	handleBack,
	hideProfileMenu,
	breadcrumbs,
	dataTagId,
}: RoutesHandlerProps) {
	const theme = useTheme();
	const {aboveMobile, isMobile} = useMediaQueries();
	const {isValid} = useContractStatus();
	const {isB2BAccess, isEarlyAccess} = useAccountInformation();

	const {isEnabled: isNotificationsFeatureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_NOTIFICATIONS,
	);
	const showNotificationsButton =
		isNotificationsFeatureFlagEnabled && isValid && !isB2BAccess && !isEarlyAccess;

	return (
		<StyledRouteContainer $isBreadcrumb={!!breadcrumbs}>
			<Stack
				flexDirection="row"
				gap={1.5}
				alignItems="center"
				overflow="hidden"
				minHeight={'48px'}>
				{handleBack ? (
					<IconButton
						onClick={handleBack}
						sx={{pl: aboveMobile ? 0 : 1}}
						data-tag-id={dataTagId?.backButtonRoute}>
						<Icon name="arrow-left-filled" color={theme.palette.common.white} />
					</IconButton>
				) : (
					<Stack sx={{width: '34px'}} />
				)}
				<Typography
					variant="h6"
					textOverflow="ellipsis"
					overflow="hidden"
					fontWeight={isMobile ? 600 : 400}
					fontSize={isMobile ? '1.25rem' : '1.5rem'}
					whiteSpace="nowrap">
					{title}
				</Typography>
			</Stack>
			{hideProfileMenu ? null : (
				<Box
					sx={{display: 'flex', alignItems: 'center', gap: isMobile ? 1 : 2, ml: 'auto'}}>
					{showNotificationsButton ? <NotificationsButton /> : null}
					<ProfileMenu />
				</Box>
			)}
			{breadcrumbs ? <Breadcrumbs paths={breadcrumbs} /> : null}
		</StyledRouteContainer>
	);
}
